import { getSearchExpandedIds as e } from "../helpers/getSearchExpandedIds.js";
import { getTreeExpansionIds as t } from "../helpers/getTreeExpansionIds.js";
import { c as n } from "react/compiler-runtime";
import { useState as r } from "react";
//#region src/components/Tree/hooks/useTreeExpansion.ts
var i = (e, t) => Array.from(e).every((e) => t.has(e)), a = (e, t) => e === t || e.size === t.size && i(e, t), o = (o) => {
	let s = n(32), { data: c, defaultExpandedIds: l, search: u, searchExpandedIds: d, resetKey: f } = o, p;
	s[0] === l ? p = s[1] : (p = l === void 0 ? [] : l, s[0] = l, s[1] = p);
	let m = p, h;
	s[2] === c ? h = s[3] : (h = t(c), s[2] = c, s[3] = h);
	let { availableIds: g, collapsibleIds: _ } = h, v;
	s[4] !== c || s[5] !== u || s[6] !== d ? (v = d ?? (u.length >= 3 ? e(c, u) : []), s[4] = c, s[5] = u, s[6] = d, s[7] = v) : v = s[7];
	let y;
	s[8] === v ? y = s[9] : (y = new Set(v), s[8] = v, s[9] = y);
	let b = y, x;
	s[10] !== m || s[11] !== u.length || s[12] !== b ? (x = () => new Set(u.length >= 3 ? b : m), s[10] = m, s[11] = u.length, s[12] = b, s[13] = x) : x = s[13];
	let S = x, C;
	s[14] !== g || s[15] !== _ || s[16] !== S || s[17] !== f || s[18] !== u || s[19] !== b ? (C = () => ({
		expandedIds: S(),
		availableIds: g,
		collapsibleIds: _,
		searchIds: b,
		search: u,
		resetKey: f
	}), s[14] = g, s[15] = _, s[16] = S, s[17] = f, s[18] = u, s[19] = b, s[20] = C) : C = s[20];
	let [w, T] = r(C), E = u !== w.search, D = !a(g, w.availableIds) || !a(_, w.collapsibleIds), O = !a(b, w.searchIds), k = !Object.is(f, w.resetKey);
	if (E || D || O || k) {
		let e = w.expandedIds;
		E || k || w.availableIds.size === 0 || u.length >= 3 && O ? e = S() : w.collapsibleIds.size > 0 && i(w.collapsibleIds, e) && (e = new Set(e), g.forEach((t) => {
			w.availableIds.has(t) || e.add(t);
		})), T({
			expandedIds: e,
			availableIds: g,
			collapsibleIds: _,
			searchIds: b,
			search: u,
			resetKey: f
		});
	}
	let A;
	s[21] === Symbol.for("react.memo_cache_sentinel") ? (A = (e) => T((t) => ({
		...t,
		expandedIds: e
	})), s[21] = A) : A = s[21];
	let j = A, { expandedIds: M } = w, N;
	s[22] !== _ || s[23] !== M ? (N = _.size > 0 && i(_, M), s[22] = _, s[23] = M, s[24] = N) : N = s[24];
	let P = N, F;
	s[25] !== g || s[26] !== P ? (F = () => j(P ? /* @__PURE__ */ new Set() : new Set(g)), s[25] = g, s[26] = P, s[27] = F) : F = s[27];
	let I = F, L;
	return s[28] !== M || s[29] !== P || s[30] !== I ? (L = {
		expandedIds: M,
		setExpandedIds: j,
		isAllExpanded: P,
		toggleExpandAll: I
	}, s[28] = M, s[29] = P, s[30] = I, s[31] = L) : L = s[31], L;
};
//#endregion
export { o as useTreeExpansion };
